import React from "react";
import {Form, FormikProps} from "formik";
import {IAuthMobileData} from "../../../contracts/data/auth";
import Button from "../../Elements/Button";
import Input from "../../Elements/Form/Input";

const InnerAuthMobileForm = (props:FormikProps<IAuthMobileData>) => {

    return(
        <Form className={"grow flex flex-col justify-between"}>
            <div>
                <div className={"mb-6"}>
                    <h2 className={"text-2xl text-semibold tracking-tight mb-6"}>ورود</h2>
                </div>
                <Input
                    name={"mobile"} meta={props?.getFieldMeta("mobile")}
                    label={"لطفا شماره موبایل خود را وارد کنید"} placeholder={"شماره موبایل..."}
                />
            </div>
            <div>
                <Button title={"ورود"} btnClassName={"w-full"} isLoading={props.isSubmitting} />
            </div>
        </Form>
    )
}

export default InnerAuthMobileForm